var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "打款明细",
        width: "960px",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c("div", { staticClass: "statement-info-card" }, [
        _c("div", { staticClass: "info-row" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("商家类型：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(
                _vm._s(
                  _vm.merchantTypeText(_vm.statementInfo.merchantType) || "-"
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("商家名称：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.statementInfo.merchantName || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("打款主体：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.statementInfo.companyName || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("对账周期：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.statementInfo.periodDesc || "-")),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action-bar" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has-permi",
                  rawName: "v-has-permi",
                  value: ["admin:merchant:statement:payment:add"],
                  expression: "['admin:merchant:statement:payment:add']",
                },
              ],
              attrs: { type: "primary", size: "small", icon: "el-icon-plus" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("新增打款")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          staticClass: "payment-table",
          attrs: {
            data: _vm.tableData,
            border: "",
            size: "mini",
            "header-cell-style": {
              background: "#f5f7fa",
              color: "#606266",
              fontWeight: "bold",
            },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "operatorName",
              label: "操作人",
              "min-width": "100",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "打款日期", "min-width": "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.paymentDate || "-"))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "打款金额", "min-width": "130", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticClass: "amount-text" }, [
                      _vm._v("￥" + _vm._s(_vm.formatAmount(scope.row.amount))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "feishuNo",
              label: "飞书申请编号",
              "min-width": "180",
              "show-overflow-tooltip": "",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "打款凭证", "min-width": "140", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      { class: scope.row.fileName ? "" : "text-muted" },
                      [_vm._v(_vm._s(scope.row.fileName || "-"))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: "打款备注",
              "min-width": "160",
              "show-overflow-tooltip": "",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "100",
              fixed: "right",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "download-btn",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleDownload(scope.row)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-download" }),
                        _vm._v(" 下载凭证\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["admin:merchant:statement:payment:delete"],
                            expression:
                              "['admin:merchant:statement:payment:delete']",
                          },
                        ],
                        staticClass: "danger-text",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("el-pagination", {
            staticClass: "pagination-wrap",
            attrs: {
              "current-page": _vm.pageParams.page,
              "page-sizes": [10, 20, 30],
              "page-size": _vm.pageParams.limit,
              layout: "total, sizes, prev, pager, next",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addDialogVisible,
            title: "新增打款",
            width: "520px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
            closed: _vm.handleAddDialogClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "实际打款金额：", prop: "amount" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: 0,
                      precision: 2,
                      controls: false,
                      placeholder: "请输入实际打款金额",
                    },
                    model: {
                      value: _vm.form.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "amount", $$v)
                      },
                      expression: "form.amount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "打款日期：", prop: "paymentDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: "请选择打款日期",
                    },
                    model: {
                      value: _vm.form.paymentDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "paymentDate", $$v)
                      },
                      expression: "form.paymentDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "飞书申请编号：", prop: "feishuNo" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入飞书申请编号",
                      clearable: "",
                      maxlength: "50",
                    },
                    model: {
                      value: _vm.form.feishuNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "feishuNo", $$v)
                      },
                      expression: "form.feishuNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "打款凭证：", prop: "voucher" } },
                [
                  _c(
                    "div",
                    { staticClass: "upload-wrap" },
                    [
                      _vm.form.voucher
                        ? _c(
                            "div",
                            { staticClass: "voucher-preview" },
                            [
                              _c(
                                "el-link",
                                {
                                  attrs: {
                                    type: "primary",
                                    href: _vm.form.voucher,
                                    target: "_blank",
                                    underline: false,
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-view" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.form.fileName || "查看已上传文件"
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ml10",
                                  attrs: { type: "text", size: "small" },
                                  on: { click: _vm.removeVoucher },
                                },
                                [_vm._v("移除")]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "primary",
                                plain: "",
                                loading: _vm.voucherUploading,
                              },
                              on: { click: _vm.triggerUpload },
                            },
                            [_vm._v("上传凭证")]
                          ),
                      _vm._v(" "),
                      _c("input", {
                        ref: "fileInputRef",
                        staticStyle: { display: "none" },
                        attrs: {
                          type: "file",
                          accept:
                            ".zip,.doc,.docx,.xls,.xlsx,.pdf,.mp3,.wma,.wav,.amr,.mp4,.pem,.p12,.png,.jpg,.jpeg",
                        },
                        on: { change: _vm.handleFileChange },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "paste-tip" }, [
                        _vm._v("在当前打款窗口支持截图后 Ctrl+V 粘贴上传凭证"),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "打款备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入打款备注",
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.addDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:merchant:statement:payment:add"],
                      expression: "['admin:merchant:statement:payment:add']",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.submitLoading,
                  },
                  on: { click: _vm.debouncedSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }